import { EditUserDto } from "./../dto";
import { AwardingClient } from "@/utils/EvoClient";

const ENDPOINT = "users/c/edit-user";

export default async function editUser(dto: EditUserDto): Promise<string> {
  return (await AwardingClient.post(ENDPOINT, dto)).data.id;
}
